import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./AboutUs.css";
import brother1 from "../../../../assets/images/brother1.png";
import { useAboutUsStore } from "../../../../store/useAboutUsStore";

const AboutOwned = () => {
  const { founder } = useAboutUsStore()
  return (
    <section className="our-safty-commitment about-owner">
      <Container className="theme-container">
        <Row className="align-items-center">
          <Col lg={4}>
            <div className="leader-img-wraper">
              <img src={founder?.image} alt="leader image" className="img-fluid" />
            </div>
          </Col>
          <Col lg={7}>
            <div className="about-owner-left-col-content ps-4">
              <p className="section-subtitle mb-2">
                {founder?.subTitle}
              </p>
              <h3 className="mb-4"> {founder?.title}</h3>
              <p className="text-light-gray mb-lg-3 mb-2">
                {founder?.description?.split("\n").map((line, idx) => (
                  <span key={idx}>
                    {line} <br />
                  </span>
                ))}
              </p>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutOwned;
